import React from 'react';
import { Hero } from './Hero';
import { StatsBar } from './StatsBar';
import { MiniTestimonials } from './MiniTestimonials';
import { PainPoints } from './PainPoints';
import { Bonuses } from './Bonuses';
import { Benefits } from './Benefits';
import { Offer } from './Offer';
import { Guarantee } from './Guarantee';
import { Testimonials } from './Testimonials';
import { FAQ } from './FAQ';
import { FinalCTA } from './FinalCTA';
import { Footer } from './Footer';
import { StickyCTA } from './StickyCTA';
import { PurchaseNotification } from './PurchaseNotification';
export function LandingPage() {
  return <div className="min-h-screen bg-white font-sans selection:bg-ocean-teal-light selection:text-ocean-teal-dark" data-id="element-137">
      <main data-id="element-138">
        <Hero data-id="element-139" />
        <StatsBar data-id="element-140" />
        <MiniTestimonials data-id="element-141" />
        <PainPoints data-id="element-142" />
        <Bonuses data-id="element-143" />
        <Benefits data-id="element-144" />
        <Offer data-id="element-145" />
        <Guarantee data-id="element-146" />
        <Testimonials data-id="element-147" />
        <FAQ data-id="element-148" />
        <FinalCTA data-id="element-149" />
      </main>
      <Footer data-id="element-150" />
      <StickyCTA data-id="element-151" />
      <PurchaseNotification data-id="element-152" />
    </div>;
}